import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDStack,
  FDAccordionGroup,
  FDAccordion,
  FDAccordionTitle,
  FDAccordionDetails,
  FDBackButton,
  FDPrimaryActionButton, FDPaper, FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CollapsibleDisclaimer from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import {
  OurInterestComparedWithNationalAverage,
} from 'Components/ComponentLibrary/Organisms/OurInterestComparedWithNationalAverage';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2HYAProposalStepLayout = ({ navigateToLink }) => {
  const {
    onSubmit, saving, resource,
  } = useMetaLayoutContext();
  return (
    <FDStack spacing={3} direction="column">
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />

      <FDPaper color="info" appearance="flat" padding={4}>
        <OurInterestComparedWithNationalAverage resource={resource} />
      </FDPaper>

      <FDAccordionGroup>
        {resource.attr('faq').resources().list().map(faq => (
          <FDAccordion expansionID={faq.id()}>
            <FDAccordionTitle><FDTitleText value={faq.attr('question')} size="lg" /></FDAccordionTitle>
            <FDAccordionDetails><FDBodyText value={faq.attr('answer')} /></FDAccordionDetails>
          </FDAccordion>
        ))}
      </FDAccordionGroup>

      <CollapsibleDisclaimer
        disclaimerText={resource.attr('disclaimer')}
        disclaimerReadMore={resource.attr('expandedDisclaimer')}
      />

      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        {resource.withRelationship(
          fr.relationships.previousLink.name,
          (rel) => <FDBackButton label="Back" onClick={() => navigateToLink(rel.link('related'))} />,
          () => null,
        )}
        {resource.meta().canSubmit()
          ? (
            <FDPrimaryActionButton
              {...dataAttrs('continue-btn', resource)}
              label="Continue"
              loading={saving}
              onClick={onSubmit}
            />)
          : null}
      </FDStack>
    </FDStack>
  );
};

AccountOpeningV2HYAProposalStepLayout.defaultProps = {
};

AccountOpeningV2HYAProposalStepLayout.propTypes = {
  navigateToLink: PropTypes.func.isRequired,
};
